@if (student.status !== awaitingStudentResponse) {
  <section>
    @if (!enableEdit) {
      <h2 class="university">University Information</h2>
      <mat-divider class="divider"></mat-divider>
      <mat-grid-list rowHeight="5rem" class="custom-grid" [gridCols]="gridCols">
        <mat-grid-tile>
          <p class="grey-text">University</p>
          <p>{{ student.university }}</p>
        </mat-grid-tile>
        @if (shouldShowDetails) {
          <mat-grid-tile>
            <p class="grey-text">Degree</p>
            <p>{{ student.degree || "-" }}</p>
          </mat-grid-tile>
          <mat-grid-tile>
            <p class="grey-text">Faculty</p>
            <p>{{ student.faculty || "-" }}</p>
          </mat-grid-tile>
          <mat-grid-tile>
            <p class="grey-text">Current Year of Study</p>
            <p>{{ getYearOfStudyString(student.yearOfStudy) || "-" }}</p>
          </mat-grid-tile>
        }
      </mat-grid-list>
      @if (isOverviewer && shouldShowDetails) {
        <mat-grid-list
          rowHeight="5rem"
          class="custom-grid"
          [gridCols]="gridCols"
        >
          <mat-grid-tile>
            <p class="grey-text">Degree duration</p>
            <p>{{ student.degreeDuration }}</p>
          </mat-grid-tile>
          <mat-grid-tile>
            <p class="grey-text">Intent to pursue honors</p>
            <p>{{ student.confirmHonors }}</p>
          </mat-grid-tile>
        </mat-grid-list>
      }
    }
    @if (enableEdit) {
      <h2 class="university">Edit University Information</h2>
      <mat-divider class="divider"></mat-divider>
      <form [formGroup]="editDetailsForm">
        <mat-grid-list
          rowHeight="7rem"
          class="custom-grid"
          [gridCols]="gridCols"
        >
          <mat-grid-tile>
            <mat-form-field appearance="outline" class="fit-content-field">
              <mat-label>University</mat-label>
              <input
                matInput
                formControlName="university"
                name="university"
                required
              />
            </mat-form-field>
          </mat-grid-tile>
          @if (shouldShowDetails) {
            <mat-grid-tile>
              <mat-form-field appearance="outline" class="fit-content-field">
                <mat-label>Degree</mat-label>
                <input matInput formControlName="degree" name="degree" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-form-field appearance="outline" class="fit-content-field">
                <mat-label>Faculty</mat-label>
                <input matInput formControlName="faculty" name="faculty" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-form-field appearance="outline" class="fit-content-field">
                <mat-label>Current Year of Study</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="yearOfStudy"
                  name="yearOfStudy"
                />
              </mat-form-field>
            </mat-grid-tile>
          }
        </mat-grid-list>
        @if (isOverviewer && shouldShowDetails) {
          <mat-grid-list
            rowHeight="7rem"
            class="custom-grid"
            [gridCols]="gridCols"
          >
            <mat-grid-tile>
              <mat-form-field appearance="outline" class="fit-content-field">
                <mat-label>Degree duration</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="degreeDuration"
                  name="degreeDuration"
                />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-form-field appearance="outline" class="fit-content-field">
                <mat-label>Intent to pursue honors</mat-label>
                <input matInput formControlName="honors" name="confirmHonors" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-form-field appearance="outline" class="fit-content-field">
                <mat-label>Department</mat-label>
                <input
                  matInput
                  formControlName="department"
                  name="department"
                />
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        }
      </form>
    }
    @if (!isStudent && shouldShowDetails) {
      <section>
        <h2 class="supporting-documents">Supporting Documents</h2>
        @for (doc of getAvailableDocuments(); track doc; let i = $index) {
          <ng-container class="supporting-docs-container">
            <section class="btn-tile">
              <section class="doc-type-view">
                <p class="support-text">{{ doc.displayName }}</p>
                <section class="document-actions">
                  <button
                    mat-flat-button
                    color="accent"
                    [disabled]="!isDocumentViewable(doc.displayName)"
                    (click)="viewDocument(doc.displayName)"
                  >
                    View
                  </button>
                  <button
                    mat-button
                    [matMenuTriggerFor]="docOptions"
                    class="kebab-menu"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #docOptions>
                    <button
                      mat-menu-item
                      [disabled]="!isDocumentViewable(doc.displayName)"
                      (click)="onDownloadDocument(doc.displayName)"
                    >
                      {{ ButtonAction.DOWNLOAD_DOCUMENT }}
                    </button>
                    @if (isOverviewer) {
                      <button
                        mat-menu-item
                        (click)="onUpdateDocument(doc.displayName)"
                      >
                        {{ ButtonAction.UPDATE_DOCUMENT }}
                      </button>
                    }
                  </mat-menu>
                </section>
              </section>
              <section class="calculated-average">
                @if (doc.gradeAverageKey) {
                  @if (
                    getAverageGrade(doc.gradeAverageKey) && editingIndex !== i
                  ) {
                    <p class="average">
                      <strong>Average grade:</strong>
                      <span class="avg-value"
                        >{{
                          averages ? averages[doc.gradeAverageKey] : null
                        }}%</span
                      >
                      @if (student?.status !== statusEnum.Declined) {
                        <button
                          mat-icon-button
                          color="primary"
                          class="small-icon-button"
                          (click)="startEditing(i)"
                        >
                          <mat-icon>edit</mat-icon>
                        </button>
                      }
                    </p>
                  } @else {
                    @if (student?.status !== statusEnum.Declined) {
                      <section class="input-row">
                        @if (editingIndex === i) {
                          <form [formGroup]="getAverageForm(i)">
                            <mat-form-field
                              appearance="outline"
                              subscriptSizing="dynamic"
                              class="compact-form-field"
                            >
                              <mat-label>Average grade</mat-label>
                              <input
                                matInput
                                formControlName="average"
                                placeholder="Input average grade"
                              />
                            </mat-form-field>
                          </form>
                          <button
                            mat-icon-button
                            color="primary"
                            class="small-icon-button"
                            [disabled]="
                              !getAverageForm(i).valid ||
                              !getAverageForm(i).get('average')?.value
                            "
                            (click)="
                              onUpdateGradeAverage(
                                doc.displayName,
                                getAverageForm(i).get('average')?.value
                              )
                            "
                          >
                            <mat-icon>done</mat-icon>
                          </button>
                          <button
                            mat-icon-button
                            color="warn"
                            class="small-icon-button"
                            (click)="cancelEditing(i)"
                          >
                            <mat-icon>close</mat-icon>
                          </button>
                        } @else {
                          <section class="input-row spaced-buttons">
                            <form [formGroup]="getAverageForm(i)">
                              <mat-form-field
                                appearance="outline"
                                subscriptSizing="dynamic"
                              >
                                <mat-label>Average grade</mat-label>
                                <input
                                  matInput
                                  formControlName="average"
                                  placeholder="Input average grade"
                                />
                              </mat-form-field>
                            </form>
                            @if (getAverageForm(i).get("average")?.value) {
                              <button
                                mat-icon-button
                                color="primary"
                                class="small-icon-button"
                                [disabled]="!getAverageForm(i).valid"
                                (click)="
                                  onUpdateGradeAverage(
                                    doc.displayName,
                                    getAverageForm(i).get('average')?.value
                                  )
                                "
                              >
                                <mat-icon>done</mat-icon>
                              </button>
                            }
                            @if (!getAverageForm(i).get("average")?.value) {
                              <mat-icon
                                color="primary"
                                aria-label="Info"
                                matTooltip="We were unable to calculate the average on this document using our tool, please verify manually"
                                >info_outline</mat-icon
                              >
                            }
                          </section>
                        }
                      </section>
                    }
                  }
                } @else {}
              </section>
            </section>
          </ng-container>
        }
      </section>
    }
    <ng-content select="[Documentation]"></ng-content>
    <ng-content select="[documentationContent]"></ng-content>
    <ng-content select="[history]"></ng-content>
    @if (shouldShowQuestionnaire) {
      <section>
        <h2 class="quesionnaire-section">Questionnaire</h2>
        <mat-divider class="divider view-here-divider"></mat-divider>
        <section class="view-responses">
          <p class="view-here">
            {{
              isStudent
                ? "View your answers to the questionnaire here:"
                : "View the student’s answers to the questionnaire here:"
            }}
          </p>
          <button mat-flat-button color="accent" (click)="viewQuestionnaire()">
            View
          </button>
        </section>
      </section>
    }
  </section>
}
